const API_BASE = import.meta.env.VITE_API_BASE_URL || "";

export type CheckoutRequest = {
  amount: number;
  currency: "PLN";
  email: string;
  customerName?: string | null;
  message: string;
  paymentChannel: "card" | "blik" | "p24";
  regulationAccepted: true;
  digitalDeliveryConsent: true;
  regulationVersion: string;
};

export type CheckoutResponse = {
  saleId: string;
  providerKey: string;
  providerSessionId: string;
  redirectUrl: string;
  amount: number;
  currency: string;
};

export type SaleStatus = {
  saleId: string;
  status:
    | "Created"
    | "Pending"
    | "Paid"
    | "Answered"
    | "Invoiced"
    | "Failed"
    | "Cancelled";
  amount: number;
  currency: string;
  email: string;
  message: string;
  responseText: string | null;
  createdAt: string;
  paidAt: string | null;
  answeredAt: string | null;
};

export type ApiError = {
  status: number;
  errors?: { field?: string; message: string }[];
  message: string;
};

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers || {}),
    },
  });

  if (!res.ok) {
    let body: { errors?: { field?: string; message: string }[] } | null = null;
    try {
      body = await res.json();
    } catch {
      // not JSON
    }
    const err: ApiError = {
      status: res.status,
      errors: body?.errors,
      message:
        body?.errors?.[0]?.message ||
        `HTTP ${res.status} ${res.statusText}`,
    };
    throw err;
  }

  return res.json() as Promise<T>;
}

export const api = {
  checkout: (body: CheckoutRequest) =>
    request<CheckoutResponse>("/api/sales/checkout", {
      method: "POST",
      body: JSON.stringify(body),
    }),
  getSale: (id: string) => request<SaleStatus>(`/api/sales/${id}`),
  getSaleByProviderSession: (providerSessionId: string) =>
    request<SaleStatus>(`/api/sales/by-provider-session/${encodeURIComponent(providerSessionId)}`),
};

export const REGULATION_VERSION = "v1";
